import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { AppSidebar } from './AppSidebar';
import { ProgramSidebar } from './ProgramSidebar';
import { ProjectNavItems } from './ProjectNavItems';
import { ProposalSidebar, PursuitSidebar, RfiSidebar, useProposalRecordShellEnabled, useRecordShellEnabled } from './RecordShell';
import { SidebarUserNav } from './SidebarUserNav';
export function Sidebar() {
    const { user } = useAuth();
    const location = useLocation();
    const params = useParams();
    const recordShell = useRecordShellEnabled();
    // Project mode covers both /project/:projectId/* and /proposal/:id routes.
    const isProjectRoute = location.pathname.startsWith('/project/') && params.projectId;
    const isProposalRoute = location.pathname.startsWith('/proposal/') && params.id;
    const isProjectMode = isProjectRoute || isProposalRoute;
    const currentProjectId = params.projectId || params.id;
    const proposalShell = useProposalRecordShellEnabled();
    // Program detail mode (/delivery/programs/:id/*).
    const programMatch = location.pathname.match(/^\/delivery\/programs\/([^/]+)/);
    const isProgramMode = !!programMatch && programMatch[1] !== undefined;
    const currentProgramId = programMatch?.[1];
    const pursuitMatch = location.pathname.match(/^\/capture\/([^/]+)/);
    const rfiMatch = location.pathname.match(/^\/rfi-response\/([^/]+)/);
    // Program mode owns the entire rail — identity, nav, and user footer — via the
    // Specra program sidebar. It manages its own collapse state.
    if (isProgramMode && currentProgramId) {
        return /*#__PURE__*/ _jsx(ProgramSidebar, {
            programId: currentProgramId
        });
    }
    // Growth record shell (FND-18): pursuit records get their own rail.
    if (recordShell && pursuitMatch?.[1]) {
        return /*#__PURE__*/ _jsx(PursuitSidebar, {
            pursuitId: pursuitMatch[1]
        });
    }
    // FND-19: RFI response records (not the create form at /rfi-response/new).
    if (recordShell && rfiMatch?.[1] && rfiMatch[1] !== 'new') {
        return /*#__PURE__*/ _jsx(RfiSidebar, {
            rfiResponseId: rfiMatch[1]
        });
    }
    // Application mode (outside a project): the Specra app rail — Dashboard plus
    // the Workflows / Tools / Admin groups. Also owns its own collapse state.
    if (!isProjectMode) {
        return /*#__PURE__*/ _jsx(AppSidebar, {});
    }
    // Growth record shell (FND-20): proposals get the record rail; /project/* keeps the legacy aside.
    if (proposalShell && isProposalRoute && currentProjectId) {
        return /*#__PURE__*/ _jsx(ProposalSidebar, {
            projectId: currentProjectId
        });
    }
    // Project mode: the logo and project selector live in the DashboardLayout top
    // bar, so the rail is just the project nav plus the user footer.
    return /*#__PURE__*/ _jsxs("aside", {
        className: "flex h-full min-h-0 w-60 flex-col overflow-hidden bg-background",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "h-3 pt-3"
            }),
            /*#__PURE__*/ _jsx(ProjectNavItems, {
                isCollapsed: false,
                projectId: currentProjectId,
                isProposal: !!isProposalRoute
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "p-2",
                children: user && /*#__PURE__*/ _jsx(SidebarUserNav, {
                    user: user,
                    isCollapsed: false
                })
            })
        ]
    });
}
